import {track} from "@otto-ec/nav_star-track";

export class AnchorContainer extends HTMLElement {
    static customElementName = "nav-anchor-container";

    constructor() {
        super();
    }

    connectedCallback() {
        this.querySelectorAll('a').forEach((el) => {
            el.addEventListener('click', (event) => {
                track(event.target, 'user-action/brand-index-visit-anchor');
            });
        });
    }
}
